<template>
  <base-legal-page
    kicker="Tiozão"
    title="Tiozão - Suporte"
  >
    <p>Estamos aqui para você aproveitar ao máximo o Tiozão.</p>

    <h2>Sobre o Tiozão</h2>
    <p>
      O Tiozão é um feed de piadas de tiozão: uma piada por página, toque no cartão para ver a resposta e deslize para a próxima. Dê a nota do aff, salve as piores, compartilhe com a família e navegue por tema ou por tipo de piada: piadas de tiozão, O que é, o que é? e Qual é o cúmulo?
    </p>

    <h2>Perguntas frequentes</h2>

    <p><strong>Por que a resposta fica escondida?</strong></p>
    <p>
      A resposta fica escondida de propósito: toque no cartão para revelar. A graça é essa.
    </p>

    <p><strong>Funciona sem internet?</strong></p>
    <p>
      Sim. Todas as piadas vêm dentro do app, então você pode ler, revelar respostas e salvar piadas sem conexão.
    </p>

    <p><strong>Quantas respostas posso ver de graça?</strong></p>
    <p>
      Todas as piadas podem ser lidas de graça, e você pode revelar cinco respostas por dia. A contagem recomeça todo dia.
    </p>

    <p><strong>O que a compra inclui?</strong></p>
    <p>
      Uma única compra, o Tiozão Completo, libera todas as respostas para sempre, incluindo os temas e piadas adicionados no futuro. Não é assinatura e não há cobrança recorrente.
    </p>

    <p><strong>Já comprei e reinstalei o app. Como recupero a compra?</strong></p>
    <p>
      Abra o Sobre a partir do feed e toque em "Restaurar compra". A Apple confirma a compra na sua conta e tudo é liberado de novo. Confira se você está com o mesmo Apple ID usado na compra.
    </p>

    <p><strong>Meu progresso fica salvo em algum lugar?</strong></p>
    <p>
      Suas piadas salvas, o histórico de leitura e as configurações ficam só no seu aparelho. Nunca são enviados para nós, o que também significa que não passam para um aparelho novo e são apagados se você apagar o app.
    </p>

    <p><strong>Como ligo ou desligo os efeitos sonoros?</strong></p>
    <p>
      Abra o Sobre a partir do feed: a opção de efeitos sonoros está lá.
    </p>

    <p><strong>O app está travando ou não funciona direito. O que eu faço?</strong></p>
    <p>Tente o seguinte:</p>
    <ul>
      <li>Confira se você tem a versão mais recente do app</li>
      <li>Feche e abra o app de novo</li>
      <li>Reinicie o aparelho</li>
    </ul>
    <p>
      Se o problema continuar, fale com a gente e informe o modelo do aparelho, a versão do iOS e a versão e o build que aparecem na tela Sobre.
    </p>

    <h2>Fale conosco</h2>
    <p>
      Se precisar de ajuda ou tiver dúvidas, sugestões ou uma piada de tiozão para mandar, escreva para a gente:
    </p>
    <div class="hh-legal__contact">
      <div><strong>E-mail:</strong> <a href="mailto:info@hackerhang.com">info@hackerhang.com</a></div>
      <div><strong>Site:</strong> <a href="https://hackerhang.com">hackerhang.com</a></div>
    </div>
  </base-legal-page>
</template>

<script>
  export default {
    name: 'TiozaoSupport',

    metaInfo: { title: 'Tiozão - Suporte' },
  }
</script>
